<h2>CHART</h2>
@for (item of filteredChartData; track item.chartReference) {
    <div class="timeline {{ item.chartReference }}">
        <div class="timeline__left-col">
            <!-- VERTICAL LABEL: Disability Date / Delivery Date -->
            <div [innerText]="item.verticalLabel" class="timeline__vertical-label"></div>
        </div>
        <div class="timeline__right-col">
            <div class="timeline__content d-flex">
                <table
                    class="timeline-table"
                    [class]="{ 'timeline-table--truncated-week-headings': item.numberOfWeekColumns === 52 }">
                    <!--  REASON BAR: <--------- Maternity | Bonding --------->
                    <thead class="timeline__reason-bar">
                        <tr>
                            @for (reason of item.reasonBarLabel; track reason.title) {
                                <th [attr.colspan]="reason.columnSpan" class="timeline__reason-bar__label">
                                    <div class="timeline__reason-bar__label-inner">
                                        <span class="timeline__reason-bar__arrow"></span>
                                        <hr class="timeline__reason-bar__hr" />
                                        <span class="timeline__reason-bar__text" [innerText]="reason.title"></span>
                                        <hr class="timeline__reason-bar__hr" />
                                        <span
                                            class="timeline__reason-bar__arrow timeline__reason-bar__arrow--right"></span>
                                    </div>
                                </th>
                            }
                        </tr>
                        <tr class="spacer-row">
                            <td colspan="2"></td>
                        </tr>
                    </thead>
                    <thead>
                        @for (title of item.weekHeadings; track title) {
                            <th>
                                <span class="timeline-table__week-label" [innerText]="title"></span>
                            </th>
                        }
                    </thead>
                    <tbody>
                        <!-- FMLA -->
                        @if (item.fmla) {
                            <tr>
                                <td [colSpan]="item.fmla.columnSpan">
                                    <div class="timeline-table__bar">
                                        <span class="timeline-table__bar-text">
                                            <span [innerText]="item.fmla.title"></span>
                                            @if (item.fmla.badge) {
                                                <span
                                                    class="timeline-table__pay-badge"
                                                    [innerText]="item.fmla.badge"></span>
                                            }
                                        </span>
                                        <img
                                            [src]="'/assets/img/ui/' + item.fmla.icon"
                                            class="timeline-table__icon"
                                            alt="" />
                                    </div>
                                </td>
                            </tr>
                        }
                        @if (item.std) {
                            <tr>
                                <!-- Waiting Period -->
                                @if (item.waitingPeriod) {
                                    <td [colSpan]="item.waitingPeriod.columnSpan">
                                        <div class="timeline-table__bar">
                                            <span class="timeline-table__bar-text">
                                                <span [innerText]="item.waitingPeriod.title"></span>
                                            </span>
                                            <img
                                                [src]="'/assets/img/ui/' + item.waitingPeriod.icon"
                                                class="timeline-table__icon"
                                                alt="" />
                                        </div>
                                    </td>
                                }
                                <!-- Short Term Disability (STD) -->
                                <td [colSpan]="item.std.columnSpan">
                                    <div class="timeline-table__bar">
                                        <span class="timeline-table__bar-text">
                                            <span [innerText]="item.std.title"></span>
                                            @if (item.std.badge) {
                                                <span
                                                    class="timeline-table__pay-badge"
                                                    [innerText]="item.std.badge"></span>
                                            }
                                        </span>
                                        <img
                                            [src]="'/assets/img/ui/' + item.std.icon"
                                            class="timeline-table__icon"
                                            alt="" />
                                    </div>
                                </td>
                            </tr>
                        }
                        <!-- Parental leave - NOT SHOWN FOR BONDING -->
                        @if (item.parentalLeave) {
                            <tr>
                                <!-- Bonding graphs have parentalLeave in week 1 so not pushed out so this addition <td> isn't needed for bonding -->
                                @if (
                                    item.chartReference !== 'oneBondingOverTwelve' &&
                                    item.chartReference !== 'twoBondingLessThanTwelve'
                                ) {
                                    @if (item.parentalLeave.columnSpan > 1 && item.std) {
                                        <td [colSpan]="item.std.columnSpan"></td>
                                    }
                                }
                                <td [colSpan]="item.parentalLeave.columnSpan">
                                    <div class="timeline-table__bar">
                                        <span class="timeline-table__bar-text">
                                            <span [innerText]="item.parentalLeave.title"></span>
                                            @if (item.parentalLeave.badge) {
                                                <span
                                                    class="timeline-table__pay-badge"
                                                    [innerText]="item.parentalLeave.badge"></span>
                                            }
                                        </span>
                                        <img
                                            [src]="'/assets/img/ui/' + item.parentalLeave.icon"
                                            class="timeline-table__icon"
                                            alt="" />
                                    </div>
                                </td>
                            </tr>
                        }
                        <!-- Unpaid leave - BONDING ONLY -->
                        @if (
                            item.chartReference === 'oneBondingOverTwelve' ||
                            item.chartReference === 'twoBondingLessThanTwelve'
                        ) {
                            @if (item.unpaidTime) {
                                <tr>
                                    <!-- Pushing Unpaid Leave to the right of the Parental Leave column number -->
                                    @if (item.parentalLeave) {
                                        <td [colSpan]="item.parentalLeave.columnSpan"></td>
                                    }
                                    <td [colSpan]="item.unpaidTime.columnSpan">
                                        <div class="timeline-table__bar">
                                            <span class="timeline-table__bar-text">
                                                <span [innerText]="item.unpaidTime.title"></span>
                                            </span>
                                            <img
                                                [src]="'/assets/img/ui/' + item.unpaidTime.icon"
                                                class="timeline-table__icon"
                                                alt="" />
                                        </div>
                                    </td>
                                </tr>
                            }
                        }
                        <!-- Long Term Disability (LTD) -->
                        @if (item.ltd) {
                            <tr>
                                <!-- Pushing LTD to the right of STD column number and/or Waiting Period if present -->
                                @if (item.waitingPeriod) {
                                    <td [colSpan]="item.waitingPeriod.columnSpan + item.std.columnSpan"></td>
                                }
                                @if (!item.waitingPeriod) {
                                    <td [colSpan]="item.std.columnSpan"></td>
                                }
                                <td [colSpan]="item.ltd.columnSpan">
                                    <div class="timeline-table__bar">
                                        <span class="timeline-table__bar-text">
                                            <span [innerText]="item.ltd.title"></span>
                                            @if (item.ltd.badge) {
                                                <span
                                                    class="timeline-table__pay-badge"
                                                    [innerText]="item.ltd.badge"></span>
                                            }
                                        </span>
                                        <img
                                            [src]="'/assets/img/ui/' + item.ltd.icon"
                                            class="timeline-table__icon"
                                            alt="" />
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    @if (item.footnoteIcons) {
        <div class="timeline-footer">
            <div class="timeline-footer__icon-keys">
                @for (footnoteIcon of item.footnoteIcons; track footnoteIcon.text) {
                    <div class="timeline-footer__icon-container">
                        <img [src]="'/assets/img/ui/' + footnoteIcon.icon" class="timeline-footer__icon-key" alt="" />
                        <span class="timeline-footer__icon-text">{{ footnoteIcon.text }}</span>
                    </div>
                }
            </div>
            @if (item.footnote) {
                <div class="timeline-footer__notes">
                    @for (note of item.footnote; track note) {
                        @if (note) {
                            <span class="d-block mb-4" [innerText]="note"></span>
                        }
                    }

                    @if (item.note) {
                        <p class="timeline-footer__note">
                            <span class="timeline-footer__note-title">{{ 'NOTE:' | translate }} </span>
                            <span class="timeline-footer__note-text" [innerText]="item.note"></span>
                        </p>
                    }
                </div>
            }
        </div>
    }
}
